import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconLookup } from '@fortawesome/fontawesome-common-types'

import { styled, Typography } from '@mui/material'
import { Icon } from '@/components/Icon/Icon'

export type IconLabelProps = {
  text: string
  label?: string
  iconName: IconLookup
  direction?: 'column' | 'row'
  color?: string
}

export const IconLabel: React.FC<IconLabelProps> = ({
  iconName,
  label,
  text,
  direction = 'column',
  color,
}) => {
  return (
    <StyledIconLabelContainer direction={direction} color={color}>
      <Icon icon={iconName} sx={{ color: color || 'inherit', fontSize: 25 }} />
      {label && (
        <StyledIconLabel variant="body1" color={color}>
          {label}
        </StyledIconLabel>
      )}
      <StyledIconText variant="body1" color={color}>
        {text}
      </StyledIconText>
    </StyledIconLabelContainer>
  )
}

const StyledIconLabelContainer = styled('div')<{ direction: 'column' | 'row'; color?: string }>(
  ({ theme, direction, color }) => ({
    display: 'flex',
    flexDirection: direction,
    alignItems: 'center',
    gap: theme.spacing(2),
    color: color || theme.palette.primary.main,
  }),
)

const StyledIconLabel = styled(Typography)<{ color?: string }>(({ theme, color }) => ({
  color: color || theme.palette.primary.main,
  fontWeight: 600,
}))

const StyledIconText = styled(Typography)<{ color?: string }>(({ theme, color }) => ({
  color: color || theme.palette.primary.main,
}))